export default __webpack_public_path__ + "static/media/IBMPlexMono-Regular.bacef25e.woff";